export default __webpack_public_path__ + "static/media/PowerOff.f0c1355e.svg";